/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var WarningStatusIcon = createIcon("WarningStatusIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#DE4E31';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.839 13.612 9.249 1.085a1.41 1.41 0 00-2.498 0L.161 13.612c-.229.435-.213.958.043 1.378.255.42.713.677 1.206.677h13.18c.493 0 .95-.257 1.206-.677.256-.42.272-.943.043-1.378ZM7.295 5.488c0-.388.316-.702.705-.702.39 0 .705.314.705.702v4.21A.703.703 0 018 10.4a.703.703 0 01-.705-.702v-4.21Zm.74 8.077h-.02a1.075 1.075 0 01-1.073-1.032 1.043 1.043 0 011.02-1.074h.021a1.076 1.076 0 011.075 1.03 1.042 1.042 0 01-1.022 1.076Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});